import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../context/I18nContext";
import { Cpu } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-8 w-8 bg-slate-900 text-white grid place-items-center rounded-sm">
              <Cpu className="h-4 w-4" />
            </div>
            <div className="font-display font-bold text-slate-900 text-[17px]">InvestGPU</div>
          </div>
          <p className="text-sm text-slate-600 max-w-md leading-relaxed">{t.footer.disclaimer}</p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-bold mb-4">Plateforme</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><Link to="/model" className="link-underline" data-testid="footer-model">{t.nav.model}</Link></li>
            <li><Link to="/invest" className="link-underline" data-testid="footer-invest">{t.nav.invest}</Link></li>
            <li><Link to="/simulator" className="link-underline" data-testid="footer-simulator">{t.nav.simulator}</Link></li>
            <li><Link to="/data-room" className="link-underline" data-testid="footer-dataroom">Data Room</Link></li>
            <li><Link to="/faq" className="link-underline" data-testid="footer-faq">{t.nav.faq}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-bold mb-4">Légal</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><Link to="/risks" className="link-underline" data-testid="footer-risks">{t.nav.risks}</Link></li>
            <li><Link to="/legal" className="link-underline" data-testid="footer-legal">{t.footer.legal}</Link></li>
            <li><Link to="/privacy" className="link-underline" data-testid="footer-privacy">{t.footer.privacy}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-5 px-6 lg:px-10 max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} InvestGPU · {t.footer.rights}</div>
      </div>
    </footer>
  );
}
